'use client'
import clsx from 'clsx'
import { useTranslations } from '@/lib/next-shim'

import { objectTypes, ObjectType } from '@/core/api/modules/document'
import { UploadButton } from '@/shared/ui/buttons/UploadButton'
import { NoFilesPlaceholder } from '@/shared/ui/placeholders/NofilesPlaceholder'
import { useUploadFile } from '@/shared/model/useUploadFile'

import type { FileProp } from '../model/types'
import { Document } from './Document'

type DocumentsSectionProps = {
  files: FileProp[]
  title: string
  showUploadButton?: boolean
  objectType?: ObjectType
  objectId?: string
  /** Drop the built-in outer gutter so the section aligns flush with its siblings. */
  flush?: boolean
}

export function DocumentsSection({ files, title, showUploadButton, objectType, objectId, flush = false }: DocumentsSectionProps) {
  const t = useTranslations()
  const [uploadFile] = useUploadFile()
  return (
    <section className="flex flex-col gap-2">
      <h3 className={clsx('section-title', !flush && 'ml-5')}>{title}</h3>
      <div className={clsx('shadow bg-white rounded-lg p-3 md:p-5', flush ? 'mt-0' : 'm-5')}>
        {files.length > 0 || showUploadButton ? (
          <div className="flex flex-wrap gap-x-4 gap-y-6">
            {files.map((file) => (
              <div key={file.key} className="w-52 max-w-full">
                <Document file={file} />
              </div>
            ))}
            {showUploadButton && (
              <div className="w-52 max-w-full">
                <UploadButton onFileUpload={(file) => uploadFile(file, objectId || '', objectType || objectTypes[0])} />
              </div>
            )}
          </div>
        ) : (
          <NoFilesPlaceholder text={t('base.noData')} />
        )}
      </div>
    </section>
  )
}
